import angular = require('angular'); 
import NewRelicBrowser = require('new-relic-browser');

import { directivesModule } from '../directivesModule';
import '../directivesModule';

export enum LogEventTypes {
	AssetClick = 'AssetClick',
	ListLoad = 'ListLoad'
}

export class Logger {
	private newrelic: typeof NewRelicBrowser = null;

	// The key in local storage to look for the user information.  
	private userKey: string = 'AppInsightsUserInfo';

	constructor(private $window: angular.IWindowService) {
		if (!$window || !$window.newrelic) {
			return;
		}

		this.newrelic = $window.newrelic;

		const user = this.getUser();
		if (user) {
			this.logUser(user.userId, user.customerId, 'new-page-launch');
		}
	}

	// Grab the user ID and account ID out of local storage.  This should ensure
	// that something in the correct form is returned even if the user is not present.  
	public getUser() {
		let result: { userId: string, customerId: string } = null;
		if (this.$window && this.$window.localStorage && this.$window.localStorage[this.userKey]) {
			result = JSON.parse(this.$window.localStorage.getItem(this.userKey));
		}
		if (!result || !result.userId || !result.customerId) {
			result = {
				userId: '', customerId: ''
			};
		}
		return result;
	}

	// Save the user information in local storage.  This should be called when the
	// user signs into the tool.  To delete the user use the clear user command.  
	public setUser(userId: string, customerId: string) {
		userId = (userId || '').replace(/[,;=| ]+/g, "_");
		customerId = (customerId || '').replace(/[,;=| ]+/g, "_");

		if (this.$window && this.$window.localStorage) {
			this.$window.localStorage.setItem(this.userKey, JSON.stringify({ userId, customerId }));
		}

		this.logUser(userId, customerId, 'login');
	}

	// Delete the user out of local storage.  
	public clearUser() {
		if (this.$window && this.$window.localStorage) {
			this.$window.localStorage.removeItem(this.userKey);
		}
	}

	public trackEvent(event: LogEventTypes, properties?: { [name:string]: string }, measurements?: { [name:string]: number }) {
		if (!this.newrelic) {
			return;
		}

		this.newrelic.addPageAction(event, properties);
	}

	public trackPageView(name?: string, appContext?:string ) {
		// New Relic natively tracks page views. Previous calls to this method for Application Insights
		// have been left in-place for reference.
		return;
	}

	private logUser(userId: string, customerId: string, loginMethod: string) {
		if (!this.newrelic) {
			return;
		}

		this.newrelic.setCustomAttribute('userId', userId);
		this.newrelic.setCustomAttribute('customerId', customerId);
		this.newrelic.addPageAction(loginMethod, {
			userId: userId,
		});
	}

}

directivesModule.factory('Logger', ['$window', ($window) => new Logger($window)]);



// WEBPACK FOOTER //
// ./Common/Logging/Logger.ts